import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button } from 'react-bootstrap';

import { StepInstanceStatus as GqlStepInstanceStatus } from '@willow/graphql-iso/src/app';
import { HydratedStepInstance, StepType } from '@willow/shared-iso';

import { ButtonLink } from '../Button/ButtonLink';

export interface WorkflowV2FormActionsProps {
  stepInstance: HydratedStepInstance<StepType>;
  submitButtonText: string;
  setStatusWithoutSubmitting: (status: GqlStepInstanceStatus) => void;
  submitAndSetStatus: (status: GqlStepInstanceStatus) => Promise<void>;
}

export const WorkflowV2FormActions = ({
  stepInstance,
  submitButtonText,
  setStatusWithoutSubmitting,
  submitAndSetStatus,
}: WorkflowV2FormActionsProps) => {
  return (
    <div className="d-flex align-items-center justify-content-end mt-3">
      {stepInstance.status !== 'active' && stepInstance.canManuallyActivate && (
        <div className="d-flex me-2">
          <Button variant="outline-primary" onClick={() => setStatusWithoutSubmitting(GqlStepInstanceStatus.Active)}>
            Activate Step
          </Button>
        </div>
      )}
      {stepInstance.status === 'active' && stepInstance.canManuallySkip && (
        <div className="flex-grow-1 workflow__form__skip-button">
          <ButtonLink className="ms-2" onClick={() => setStatusWithoutSubmitting(GqlStepInstanceStatus.Skipped)}>
            Skip Step
          </ButtonLink>
        </div>
      )}
      <Button type="submit" variant="outline-primary" className="workflow__form__submit-button me-2">
        {submitButtonText}
      </Button>
      {stepInstance.status === 'active' && stepInstance.canManuallyFail && (
        <Button
          className="me-2 workflow__form__fail-button"
          variant="outline-danger"
          onClick={() => setStatusWithoutSubmitting(GqlStepInstanceStatus.Failed)}
        >
          <CloseOutlined /> Fail & Close Step
        </Button>
      )}
      {stepInstance.status === 'active' && stepInstance.canManuallyComplete && (
        <Button
          className="me-2 workflow__form__complete-button"
          variant="outline-success"
          onClick={() => submitAndSetStatus(GqlStepInstanceStatus.Completed)}
        >
          <CheckOutlined /> Complete & Close Step
        </Button>
      )}
    </div>
  );
};
